import React from "react";
import TextHome from "../components/content/TextHome";

function TextArticlePage() {
  return(<TextHome/>)
}

export default TextArticlePage;